import { prefix } from '../../utils/prefix';

const Url = {
  getNationality: `${prefix}/dataset/nationality`, // 获取国籍
  getNation: `${prefix}/dataset/nation`, // 获取民族(与国籍有联动)
  getProvince: `${prefix}/dataset/province`, // 获取省份(与国籍有联动)
  getCity: `${prefix}/dataset/city`, // 获取城市(与国籍有联动)
};

export default Url;
